"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataHooks = void 0;
exports.dataHooks = {
    hiddenRadio: 'hidden-radio',
    label: 'label',
    icon: 'icon',
};
//# sourceMappingURL=constants.js.map